import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  ActualizeazaTargetareListaRequest,
  ActualizeazaTargetareListaResponse,
  DecideTargetareListaPropunereRequest,
  DecideTargetareListaPropunereResponse,
  GetTargetareListaPropuneriResponse,
  CautaTargetareFirmaResponse,
  GetTargetareFirmeCriteriuRequest,
  GetTargetareFirmeCriteriuResponse,
  GetTargetareListaVersiuneResponse,
  GetTargetareListeResponse,
  GetTargetareMapareResponse,
  GetTargetareScoruriResponse,
  ImportaTargetareListaRequest,
  ImportaTargetareListaResponse,
  PreiaTargetareListaRequest,
  PreiaTargetareListaResponse,
  SalveazaTargetareAmbiguitateRequest,
  SalveazaTargetareAmbiguitateResponse,
  SalveazaTargetareListaFisierRequest,
  SalveazaTargetareListaFisierResponse,
  SalveazaTargetareMapareRequest,
  SalveazaTargetareMapareCodRequest,
  SalveazaTargetareMapareCodResponse,
  SalveazaTargetareMapareResponse,
  SalveazaTargetareScorRequest,
  SalveazaTargetareScorResponse,
  StergeTargetareListaFisierResponse,
  StergeTargetareListaRanduriRequest,
  StergeTargetareListaRanduriResponse,
} from "@/api/types/targetareConfig";

function assertSuccess(data: unknown, endpoint: string): void {
  if (
    !data ||
    typeof data !== "object" ||
    (data as { success?: unknown }).success !== true
  ) {
    throw new Error(`Răspuns invalid de la ${endpoint}`);
  }
}

async function apel<T>(
  cale: string,
  method: "GET" | "POST" | "DELETE",
  body?: unknown
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/${cale}`,
    body === undefined ? { method } : { method, body }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, `targetare/${cale}`);
  return data as T;
}

export const getTargetareMapare = () =>
  apel<GetTargetareMapareResponse>("mapare", "GET");

export const salveazaTargetareMapare = (
  cerere: SalveazaTargetareMapareRequest
) => apel<SalveazaTargetareMapareResponse>("mapare", "POST", cerere);

export const salveazaTargetareMapareCod = (
  cerere: SalveazaTargetareMapareCodRequest
) => apel<SalveazaTargetareMapareCodResponse>("mapare/cod", "POST", cerere);

export const getTargetareScoruri = () =>
  apel<GetTargetareScoruriResponse>("scoruri", "GET");

export const salveazaTargetareScor = (cerere: SalveazaTargetareScorRequest) =>
  apel<SalveazaTargetareScorResponse>("scoruri/scor", "POST", cerere);

export const salveazaTargetareAmbiguitate = (
  cerere: SalveazaTargetareAmbiguitateRequest
) =>
  apel<SalveazaTargetareAmbiguitateResponse>(
    "scoruri/ambiguitate",
    "POST",
    cerere
  );

export const getTargetareListe = () =>
  apel<GetTargetareListeResponse>("liste", "GET");

export const salveazaTargetareListaFisier = (
  cerere: SalveazaTargetareListaFisierRequest
) => apel<SalveazaTargetareListaFisierResponse>("liste/fisier", "POST", cerere);

export const stergeTargetareListaFisier = (numeFisier: string) =>
  apel<StergeTargetareListaFisierResponse>(
    `liste/fisier?nume_fisier=${encodeURIComponent(numeFisier)}`,
    "DELETE"
  );

export const importaTargetareLista = (cerere: ImportaTargetareListaRequest) =>
  apel<ImportaTargetareListaResponse>("liste/import", "POST", cerere);

export const actualizeazaTargetareLista = (
  cerere: ActualizeazaTargetareListaRequest
) =>
  apel<ActualizeazaTargetareListaResponse>(
    "liste/actualizeaza",
    "POST",
    cerere
  );

export const stergeTargetareListaRanduri = (
  cerere: StergeTargetareListaRanduriRequest
) =>
  apel<StergeTargetareListaRanduriResponse>(
    "liste/randuri/sterge",
    "POST",
    cerere
  );

export const getTargetareListaVersiune = (id: number) =>
  apel<GetTargetareListaVersiuneResponse>(`liste/versiuni/${id}`, "GET");

export const preiaTargetareLista = (cerere: PreiaTargetareListaRequest) =>
  apel<PreiaTargetareListaResponse>("liste/preia", "POST", cerere);

export const getTargetareFirmeCriteriu = (
  cerere: GetTargetareFirmeCriteriuRequest
) => apel<GetTargetareFirmeCriteriuResponse>("firme/criteriu", "POST", cerere);

export const cautaTargetareFirma = (q: string) =>
  apel<CautaTargetareFirmaResponse>(
    `firme/cauta?q=${encodeURIComponent(q)}`,
    "GET"
  );

export const getTargetareListaPropuneri = () =>
  apel<GetTargetareListaPropuneriResponse>("liste/propuneri", "GET");

export const decideTargetareListaPropunere = (
  cerere: DecideTargetareListaPropunereRequest
) =>
  apel<DecideTargetareListaPropunereResponse>(
    "liste/propuneri/decide",
    "POST",
    cerere
  );
